import { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Controls from "./Controls";
import ObjectList from "../ObjectList";
import HorizontalNavbar from "./HorizontalNavbar";
import VerticalNavbar from "./VerticalNavbar";
import { useGetDomain } from '../../common/Hooks';

const Header = () => {
    const history = useHistory();
    const [showMenu, setShowMenu] = useState(false);
    const [translate] = useTranslation();
    const [domain] = useGetDomain();

    const header = useMemo(() => {
        return (
            <>
                <header className="fixed-top navbar navbar-expand-lg navbar-dark bg-secondary">
                    <button className="navbar-toggler collapsed" onClick={() => setShowMenu(true)}>
                        <span icon="List" className="navbar-toggler-icon"></span>
                    </button>
                    <a className="navbar-brand" href="/" onClick={(event) => { event.preventDefault(); history.push("/") }}>
                        <img src="/logo.svg" className="logo" alt="Cœptis - by OnTheMove" />
                    </a>
                    <Controls />
                </header>

                <HorizontalNavbar />

                <Offcanvas show={showMenu} onHide={() => setShowMenu(false)} className="bg-light">
                    <Offcanvas.Header closeButton closeVariant="white" className="justify-content-between bg-secondary">
                        <label className="d-block h6 text-white">{`${translate("OTM_CONFIGURE")} - ${domain.name}`}</label>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <VerticalNavbar />
                        <ObjectList onClick={() => setShowMenu(false)} />
                    </Offcanvas.Body>
                </Offcanvas>
            </>
        );
    }, [showMenu, history, translate, setShowMenu, domain.name]);

    return header;
};

export default Header;